import api from '@/utils/api';

/**
 * Get a Quote Module
 * @param {string} companyId - the companyId
 * @param {string} quoteModuleId - the quote module id
 * @returns {Promise}
 */
const getQuoteModuleApi = (companyId, quoteModuleId) =>
  api.get(`/company/${companyId}/quote-module/${quoteModuleId}`);

export default getQuoteModuleApi;
